import React from 'react';
import PropTypes from 'prop-types';
import './NotifyGdaPage.scss';
import { getAuthModalStyles } from '../Notify/notifyUtils';
import Modal from '../Modal';
import NotifyGdaPage, { NotifyGdaPagePropType } from './NotifyGdaPage';

const NotifyGdaModal = ({
  isOpen, onClose, matchMedia, data, Analytics,
}) => (
  <Modal
    isOpen={isOpen}
    styles={getAuthModalStyles(matchMedia)}
  >
    <NotifyGdaPage
      Analytics={Analytics}
      onClose={onClose}
      isMobile={!matchMedia.md}
      {...data}
    />
  </Modal>
);

NotifyGdaModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func.isRequired,
  }).isRequired,
  data: NotifyGdaPagePropType,
};

NotifyGdaModal.defaultProps = {
  isOpen: false,
  data: {},
};

export default NotifyGdaModal;
